import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { Link, useNavigate } from 'react-router-dom';
import { FileForm } from '@/components/features/tasks/invoice/[invoice_task_id]/InvoiceTaskFileEditForm/FileForm';
import { UrlForm } from '@/components/features/tasks/invoice/[invoice_task_id]/InvoiceTaskFileEditForm/UrlForm';
import { DocumentsElement } from '@/components/features/tasks/invoice/[invoice_task_id]/InvoiceTaskFileEditForm/DocumentsElement';
import { MoneyForwardForm } from '@/components/features/tasks/invoice/[invoice_task_id]/InvoiceTaskFileEditForm/MoneyForwardForm';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';

export const InvoiceTaskFileEditForm = () => {
  const navigate = useNavigate();
  const { _w_, _t_ } = useCurrentTeamMember();
  const { invoiceTask: task } = useCurrentInvoiceTask();

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12 col-lg-9 mx-auto">
          <div className="card mb-4" id="basic-info">
            <div className="card-header d-flex align-items-center">
              <div className="col-md-8">
                <h5 className="mb-1">請求書等ファイル一覧</h5>
                <p className="text-xs mb-0">請求書等関連ファイルを管理します。</p>
              </div>
            </div>
            <div className="card-body pt-0 row">
              <div className="form-group">
                <label>タスク名</label>
                <p className="form-text text-muted text-sm ms-1">{task!.name}</p>
              </div>

              <MoneyForwardForm />

              {_w_!.money_forward_setting ? (
                <div className="mb-2 position-relative text-center">
                  <p className="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3">
                    or
                  </p>
                </div>
              ) : (
                <hr className="horizontal dark my-3" />
              )}

              <FileForm />

              <div className="mb-2 position-relative text-center">
                <p className="text-sm font-weight-bold mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3">
                  or
                </p>
              </div>

              <UrlForm />

              <hr className="horizontal dark my-3" />

              <DocumentsElement />
            </div>
            <div className="card-footer d-flex align-items-center justify-content-end pt-0">
              <Link to="" className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                タスク詳細へ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
